import { render, staticRenderFns } from "./dzOrder.vue?vue&type=template&id=b9c07a32&scoped=true&"
import script from "./dzOrder.vue?vue&type=script&lang=js&"
export * from "./dzOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c07a32",
  null
  
)

export default component.exports